import React from 'react';
import Button from '../ui/Button';
import { motion } from 'framer-motion';
//import { db } from '../../../firebase/config';
//import { collection, addDoc } from 'firebase/firestore';
import { useNotifications } from "../../utils/NotificationContext/NotificationContext";

import {
  FaBell,
  FaUserShield,
  FaCheckCircle
} from 'react-icons/fa';
import styles from './Step5Preferences.module.css';

const stepVariants = {
  hidden: { opacity: 0, x: 100 },
  visible: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -100 },
};

const Step5Preferences = ({ prevStep, setFormData, formData, OnhandleSubmit }) => {
  const { notify } = useNotifications();
  const handleChange = e => {
    const { name, type, value, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    if (!formData.terms) {
	  notify('info', 'You must agree to the Terms and Conditions.');
      return;
    }
	if(OnhandleSubmit != null)OnhandleSubmit(e);
  };

  return (
    <>
      <h2 className={styles.stepTitle}>Preferences & Agreements</h2>

      {/* Notifications */}
      <div className={styles.inputGroup}>
        <label htmlFor="notifications">
          <FaBell className={styles.icon} />
          <input
            type="checkbox"
            id="notifications"
            name="notifications"
            checked={formData.notifications || false}
            onChange={handleChange}
          />
          &nbsp;Receive Notifications
        </label>
        <small className={styles.helperText}>We'll notify you about new debates and activity.</small>
      </div>

      {/* Privacy */}
      <div className={styles.inputGroup}>
        <label htmlFor="privacy">
          <FaUserShield className={styles.icon} />
          Privacy Settings
        </label>
        <select
          id="privacy"
          name="privacy"
          className={styles.inputField}
          value={formData.privacy || 'public'}
          onChange={handleChange}
        >
          <option value="public">Public</option>
          <option value="friends">Friends Only</option>
          <option value="private">Private</option>
        </select>
        <small className={styles.helperText}>
          Who can view your profile and debate activity.
        </small>
      </div>

      {/* Terms */}
      <div className={styles.inputGroup}>
        <label htmlFor="terms">
          <FaCheckCircle className={styles.icon} />
          <input
            type="checkbox"
            id="terms"
            name="terms"
            checked={formData.terms || false}
            onChange={handleChange}
            required
          />
          &nbsp;I agree to the Terms and Conditions
        </label>
        <small className={styles.helperText}>
          Required to complete registration.
        </small>
      </div>

		<div className={styles.navbuts}>
        <Button variant="secondary" className={styles.prevButton} onClick={prevStep}>Back</Button>
        <Button variant="primary" className={styles.submitButton} onClick={handleSubmit}>Submit</Button>
      </div>
    </>
  );
};

export default Step5Preferences;
